const STORAGE_KEY = 'super_admin_activity_logs_v1';
const MAX_LOGS = 120;

export const getAdminActivityLogs = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const appendAdminActivityLog = (entry) => {
  try {
    const prev = getAdminActivityLogs();
    const next = [
      {
        id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        level: entry?.level || 'info',
        action: entry?.action || 'unknown',
        message: entry?.message || '',
        context: entry?.context || null,
        createdAt: new Date().toISOString(),
      },
      ...prev,
    ].slice(0, MAX_LOGS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return next;
  } catch {
    return getAdminActivityLogs();
  }
};

